export default __webpack_public_path__ + "static/media/compass-min.4a93bf6b.jpg";